/* eslint-disable no-unused-expressions */
import React, { useCallback, useEffect } from 'react';

import { useTranslation } from 'react-i18next';

import styled from 'styled-components';

import { useReports, useBreakpoint } from '@hooks';
import { PaginationMov, NoMoreMovements } from '@components';

const PaginationContainer = styled.div`
  padding-top: 8px;
  margin-top: 16px;
`;

export const Pagination = () => {
  const {
    pagination,
    setCurrentPage,
    reports: totalReports,
    reportsTypeToShow,
    setReportsRangeToShow,
  } = useReports();
  const { per_page: itemsPerPage, current_page: currentPage } = pagination;
  const { mobile } = useBreakpoint();
  const { t } = useTranslation();

  const endReports = currentPage * itemsPerPage > totalReports.length;

  const handleSetDate = useCallback((range, endScroll) => {
    const nextPage = range[1] / itemsPerPage;
    // Se necesita validar si esta afuera del rango aceptable ya que el el scroll en mobile
    // tira el evento una vez mas de la necesaria al scrollear todo el contenido que hay
    currentPage !== nextPage && setCurrentPage(nextPage);
    // if (!(range[1] - reports.length > itemsPerPage)) setCurrentPage(nextPage);
    // Si ya mostramos todos los registros no hace falta cambiar el rango
    if (!endScroll) setReportsRangeToShow(range);
  });

  useEffect(() => {
    if (!mobile) {
      // volvemos al estado inicial en web debido a que el rango a mostrar es diferente
      // al de mobile (por el infinite-scroll)
      setReportsRangeToShow([0, itemsPerPage]);
      setCurrentPage(1);
    }
  }, [mobile]);

  const reports = reportsTypeToShow || totalReports;

  return (
    <>
      {reports.length > itemsPerPage && (
        <PaginationContainer>
          <PaginationMov
            endScroll={endReports}
            infinityScroll={[0, currentPage * itemsPerPage]}
            itemsPerPage={itemsPerPage}
            movements={reports}
            setData={handleSetDate}
          />
        </PaginationContainer>
      )}
      {endReports && mobile && reports.length !== 0 && (
        <PaginationContainer>
          <NoMoreMovements> {t('reportsScreen.noMoreReports')}</NoMoreMovements>
        </PaginationContainer>
      )}
    </>
  );
};
